// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const guineaFowl = defineModel({
  id: "guinea-fowl",
  batchId: "future",
  name: "Guinea fowl",
  tags: ["creature","guinea","fowl","low-poly","age-of-mcp","future"],
  summary: "Guinea fowl — meat, eggs and tick and pest control.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.0045, 0.0035, 0.04, 4), color: "#5a4a3a", position: [0.005, 0.02, 0.016] },
      { geometry: new THREE.CylinderGeometry(0.0045, 0.0035, 0.04, 4), color: "#5a4a3a", position: [0.005, 0.02, -0.016] },
      { geometry: new THREE.IcosahedronGeometry(0.052, 0), color: "#3a4048", position: [0, 0.08, 0], scale: [1.2, 1.15, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: "#474e57", position: [-0.04, 0.085, 0], scale: [1.1, 1, 1] },
      { geometry: new THREE.CylinderGeometry(0.007, 0.009, 0.026, 5), color: "#c8d2dc", position: [0.05, 0.115, 0], rotation: [0, 0, -0.5] },
      { geometry: new THREE.IcosahedronGeometry(0.013, 0), color: "#c8d2dc", position: [0.062, 0.138, 0] },
      { geometry: new THREE.ConeGeometry(0.006, 0.016, 5), color: "#9a8a6a", position: [0.06, 0.156, 0], rotation: [-0.2, 0, 0] },
      { geometry: new THREE.ConeGeometry(0.005, 0.012, 4), color: "#d8b24a", position: [0.076, 0.135, 0], rotation: [0, 0, -1.5] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#c54a3a", position: [0.07, 0.125, 0.008] },
      { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#c54a3a", position: [0.07, 0.125, -0.008] },
      { geometry: new THREE.IcosahedronGeometry(0.003, 0), color: "#181410", position: [0.07, 0.142, 0.009] },
      { geometry: new THREE.IcosahedronGeometry(0.003, 0), color: "#181410", position: [0.07, 0.142, -0.009] },
    ],
  animations: [],
});
